import { render } from "./LandlordsPage.vue?vue&type=template&id=196e02ba&scoped=true"
import script from "./LandlordsPage.vue?vue&type=script&lang=js"
export * from "./LandlordsPage.vue?vue&type=script&lang=js"

import "./LandlordsPage.vue?vue&type=style&index=0&id=196e02ba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Verent_PactoAdmin_FE_UI/Verent_PactoAdmin_FE_UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196e02ba"]])

export default __exports__